module.exports = __webpack_public_path__ + "static/media/dryer-light-gray.81947ec9.svg";